export function ScanPanel({ scanLoading, scanResult, onScan }) {
  return (
    <>
      <div className="form-row">
        <button className="btn btn-primary" onClick={onScan} disabled={scanLoading}>
          {scanLoading ? 'Scanning Dayforce (this takes ~30s)...' : 'Scan Dayforce'}
        </button>
        <span style={{ fontSize: 12, color: '#666', alignSelf: 'center' }}>
          Probes Dayforce API to find what date range has data, then sets Start/End dates automatically
        </span>
      </div>

      {scanLoading && (
        <div className="alert alert-info">
          Scanning Dayforce API across multiple years to find available data... This takes about 30-60 seconds.
        </div>
      )}

      {scanResult && (
        <div
          style={{
            fontSize: 13, color: '#002159', marginBottom: 16, padding: '10px 14px',
            background: '#f0f4fa', borderRadius: 6, borderLeft: '4px solid #FF6600',
          }}
        >
          <strong>Dayforce Punches Data Available:</strong>{' '}
          {scanResult.earliest_date} to {scanResult.latest_date}
        </div>
      )}
    </>
  );
}
